<template>
  <div>
    <b-table
      striped
      hover
      responsive
      :fields="fields"
      :items="dataList"
    >
      <template #custom-foot>
        <b-tr>
          <b-th>
            Toplam
          </b-th>
          <b-th class="text-center">
            {{ grandTotals.sales }}
          </b-th>
          <b-th class="text-center">
            {{ grandTotals.connections }}
          </b-th>
          <b-th class="text-center">
            {{ grandTotals.stocks }}
          </b-th>
        </b-tr>
      </template>
    </b-table>
  </div>
</template>
<script>
import {
  BTable, BTr, BTh,
} from 'bootstrap-vue'

export default {
  name: 'ListTable',
  components: {
    BTable,
    BTr,
    BTh,
  },
  props: {
    dataList: {
      type: Array,
      required: true,
    },
    grandTotals: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      fields: [
        {
          key: 'title',
          label: 'Marka',
          sortable: true,
        },
        {
          key: 'sales',
          label: 'Satış Adet',
          sortable: true,
          thClass: 'text-center width-200',
          tdClass: 'text-center',
        },
        {
          key: 'connections',
          label: 'Bağlantı Adet',
          sortable: true,
          thClass: 'text-center width-200',
          tdClass: 'text-center',
        },
        {
          key: 'stocks',
          label: 'Stok Adet',
          sortable: true,
          thClass: 'text-center width-200',
          tdClass: 'text-center',
        },
      ],
    }
  },
}
</script>
